import {Component, HostListener, inject, Input} from '@angular/core';
import {RecordTableColumnParams} from "../../../../../types/records-table.types";
import {TableGroupHeaderService} from "../../../../../services/table-services/table-group-header.service";

@Component({
  selector: 'div[app-hidden-group]',
  standalone: false,
  templateUrl: './hidden-group.component.html',
  styleUrl: './hidden-group.component.scss'
})
export class HiddenGroupComponent {
  @Input({ required: true }) resourceParamsKey: string = '';
  @Input({ required: true }) columnParams!: RecordTableColumnParams;

  @HostListener('click', ['$event'])
  handleHiddenGroupClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.tableGroupHeaderService.toggleGroupVisibility(this.resourceParamsKey, this.columnParams);
  }

  private tableGroupHeaderService: TableGroupHeaderService = inject(TableGroupHeaderService);
}
